<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item active">
						{{ $t('EqAsMaterial') }}
					</li>
				</ol>
			</nav>
			<div class="item-box mb-3">
				<h3 class="item-title">
					{{ $t('EqAsMaterial') }}
				</h3>
				<template v-if="clientWidth > 1000 && itemList.length > 0">
					<div class="row">
						<div class="col-12 position-relative" v-for="(item, index) in itemList" v-if="item && item.children.length > 0">
							<ul class="treeRq horizontal">
								<TreeView :node="item" />
							</ul>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="tree" v-for="(item, index) in itemList" v-if="item && item.children.length > 0 && itemList.length > 0">
						<ul>
							<MobileTreeView :node="item" />
						</ul>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import TreeView from "@/components/RequireTree.vue";
import MobileTreeView from "@/components/RequireTreeMobile.vue";
export default {
	name: "EquipmentRequire",
	props: ["clientWidth"],
	components: { TreeView, MobileTreeView },
	data() {
		return {
			itemList: [],
		};
	},
	metaInfo() {
		return {
			title: "裝備素材需求表",
			meta: [{ name: "description", content: this.rdescription + "超異域公主連結☆Re:Dive Wiki 蘭德索爾圖書館" }],
		};
	},
	methods: {
		getRequireEq: function(itemId) {
			var self = this;
			var list = _.filter(self.$store.getters.getEquipmentCraft, function(o) {
				if (o.equipment_id == itemId) {
					return false;
				}
				return _.includes(o, itemId);
			});
			var test = self.findTopTreeEq(itemId);
			self.itemRequire = test;
		},
		getRequireEq: function(itemId) {
			var self = this;
			var list = _.filter(self.$store.getters.getEquipmentCraft, function(o) {
				if (o.equipment_id == itemId) {
					return false;
				}
				return _.includes(o, itemId);
			});
			return self.findTopTreeEq(itemId);
		},
		findTopTreeEq: function(itemId) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", itemId]);
			let data = {
				parent_id: itemId,
				consume: 1,
				children: [],
			};
			if (!eq) {
				return data;
			}
			var subEq = _.filter(self.$store.getters.getEquipmentCraft, function(o) {
				if (o.equipment_id == itemId) {
					return false;
				}
				if (_.includes(o, itemId)) {
					return o.equipment_id;
				}
			});
			if (subEq.length == 0) {
				return data;
			}
			_.forEach(subEq, function(item) {
				data["children"].push(self.findTopTreeEq(item.equipment_id));
			});
			return data;
		},
	},
	created: function() {
		var self = this;
		var itemList = [];
		_.forEach(self.$store.getters.getEquipmentData, function(o) {
			if (o.craft_flg == "1") {
				try {
					itemList.push(self.getRequireEq(o.equipment_id));
				} catch (e) {
					console.log(e);
				}
			}
		});
		this.itemList = itemList;
	},
	computed: {},
	mounted: function() {},
};
</script>
<style>
.treeRq {
	margin: 0;
	background-color: #fff;
	border-right: 5px;
	margin-bottom: 15px;
	padding-bottom: 20px;
	padding-top: 20px;
}

.tree {
	margin: 0;
	background-color: #fff;
	border-right: 5px;
	margin-bottom: 15px;
	padding: 20px;
}

.treeRq:not(:empty):before,
.treeRq:not(:empty):after,
.treeRq ul:not(:empty):before,
.treeRq ul:not(:empty):after,
.treeRq li:not(:empty):before,
.treeRq li:not(:empty):after {
	display: block;
	position: absolute;
	content: "";
}

.treeRq a {
	margin: 10px 0;
}

.treeRq ul,
.treeRq li {
	position: relative;
	margin: 0;
	padding: 0;
}

.treeRq li {
	list-style: none;
}

.treeRq li > div {
	background-color: #eee;
	color: #222;
	padding: 5px;
	display: inline-block;
}

.treeRq.horizontal li {
	display: flex;
	align-items: center;
	margin-left: 24px;
}

.treeRq.horizontal li div {
	margin: 6px 0;
}

.treeRq.horizontal li:before {
	border-left: 1px solid #ddd;
	height: 100%;
	width: 0;
	top: 0;
	left: -12px;
	content: "";
}

.treeRq.horizontal li:first-child:before {
	height: 50%;
	top: 50%;
	content: "";
}

.treeRq.horizontal li:last-child:before {
	height: 50%;
	bottom: 50%;
	top: auto;
	content: "";
}

.treeRq.horizontal li:after,
.treeRq.horizontal li ul:after {
	border-top: 1px solid #ddd;
	height: 0;
	width: 12px;
	top: 50%;
	left: -12px;
	content: "";
}

.treeRq.horizontal li:only-child:before {
	content: none;
}

.treeRq.horizontal li ul:after {
	left: 0;
	content: "";
}

.treeRq.horizontal > li:only-child {
	margin-left: 0;
	content: "";
}

.treeRq.horizontal > li:only-child:before,
.treeRq.horizontal > li:only-child:after {
	content: none;
}
.tree > ul {
	padding-left: 0px;
}
.tree {
	margin-bottom: 20px;
}
</style>
